module.exports = __webpack_public_path__ + "img/q1.0cec63fa.png";